import { render } from "./LoginSuccessView.vue?vue&type=template&id=06812738&scoped=true"
import script from "./LoginSuccessView.vue?vue&type=script&lang=js"
export * from "./LoginSuccessView.vue?vue&type=script&lang=js"

import "./LoginSuccessView.vue?vue&type=style&index=0&id=06812738&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06812738"]])

export default __exports__